module.exports = __webpack_public_path__ + "static/media/ios-skip-backward.53305148.svg";